/* Thobe Wala product cards (v34, 13 Oct 2026): photo arrows + wishlist heart.
   Works for cards added later too (filters, load more, quick view) because it listens on the document. */
// pagination.js calls StampedFn.loadBadges (reviews app, not installed) after every load - give it a harmless stub
window.StampedFn = window.StampedFn || {};
(function () {
  'use strict';
  var KEY = 'tw_wishlist';

  function readWish() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function writeWish(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }

  function paintWish(root) {
    var list = readWish();
    (root || document).querySelectorAll('.tw-card__wish').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.dataset.handle) > -1 ? 'true' : 'false');
    });
  }

  function slide(card, dir) {
    var fig = card.querySelector('[data-tw-images]');
    if (!fig) return;
    var urls = fig.getAttribute('data-tw-images').split('|');
    var i = ((parseInt(card.dataset.twIndex || '0', 10) + dir) % urls.length + urls.length) % urls.length;
    card.dataset.twIndex = i;
    var img = card.querySelector('.tw-card__slide');
    if (!img) return;
    if (i === 0) { img.hidden = true; card.classList.remove('is-sliding'); return; }
    img.src = urls[i];
    img.hidden = false;
    card.classList.add('is-sliding');
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.tw-card__arrow');
    if (arrow) {
      e.preventDefault(); e.stopPropagation();
      slide(arrow.closest('.tw-card'), arrow.classList.contains('tw-card__arrow--prev') ? -1 : 1);
      return;
    }
    var wish = e.target.closest('.tw-card__wish');
    if (wish) {
      e.preventDefault();
      var h = wish.dataset.handle, list = readWish(), at = list.indexOf(h);
      if (at > -1) list.splice(at, 1); else list.push(h);
      writeWish(list);
      paintWish();
    }
  });

  // keyboard: Enter / Space on Quickshop (it is a custom element, not a real button)
  document.addEventListener('keydown', function (e) {
    var qs = e.target.closest && e.target.closest('.tw-card__quickshop');
    if (qs && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); qs.click(); }
  });

  // swipe on phones
  var sx = 0, sy = 0;
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('[data-tw-images]')) return;
    sx = e.touches[0].clientX; sy = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    var fig = e.target.closest('[data-tw-images]');
    if (!fig || !sx) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    sx = 0;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) slide(fig.closest('.tw-card'), dx < 0 ? 1 : -1);
  }, { passive: true });


  /* ---- v37: rotating photos in the Men / Kids mega menu (data-tw-pool set by header-full-menu-promotion.liquid) ---- */
  function rotatePools() {
    document.querySelectorAll('.mega-menu-promotion[data-tw-pool]').forEach(function (box, n) {
      var urls = box.getAttribute('data-tw-pool').split('|').filter(Boolean);
      var img = box.querySelector('img');
      if (!img || urls.length < 2) return;
      var key = 'tw_rot_menu_' + n, last = -1;
      try { last = parseInt(localStorage.getItem(key) || '-1', 10); } catch (e) {}
      var i = Math.floor(Math.random() * urls.length);
      if (i === last) i = (i + 1) % urls.length;
      try { localStorage.setItem(key, String(i)); } catch (e) {}
      var u = urls[i];
      img.removeAttribute('data-srcset');
      img.setAttribute('srcset', [450, 670, 900].map(function (w) { return u.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', '));
      img.src = u;
      img.style.objectPosition = '50% 25%';
    });
  }
  rotatePools();


  /* ---- v37b: photo tiles cycle with a crossfade, one tile at a time (left, then right; 1, 2, 3 ... then again) ----
     Works on any [data-tw-pool] tile except the mega menu. A new image layer fades in over the old one only after it
     has loaded, so there is never a blank frame. Pauses off-screen, in hidden tabs and for reduced-motion users. */
  var STEP = 2500, FADE = 1200;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function groupsOf() {
    var map = new Map();
    document.querySelectorAll('[data-tw-pool]').forEach(function (box) {
      if (box.closest('.mega-menu-promotion') || box.classList.contains('mega-menu-promotion')) return;
      var urls = box.getAttribute('data-tw-pool').split('|').filter(Boolean);
      if (urls.length < 2) return;
      var sec = box.closest('.shopify-section') || document.body;
      if (!map.has(sec)) map.set(sec, []);
      map.get(sec).push({ box: box, urls: urls });
    });
    return map;
  }
  function currentSrc(box) {
    var imgs = box.querySelectorAll('img');
    var top = imgs[imgs.length - 1];
    return top ? (top.currentSrc || top.src || '') : '';
  }
  function fadeTo(tile) {
    var box = tile.box, base = box.querySelector('img');
    if (!base) return;
    var cur = currentSrc(box).split('?')[0], pick, tries = 0;
    do { pick = tile.urls[Math.floor(Math.random() * tile.urls.length)]; tries++; }
    while (pick.split('?')[0] === cur && tries < 6);
    var layer = new Image();
    layer.className = 'tw-xf';
    layer.alt = '';
    layer.decoding = 'async';
    layer.srcset = [600, 900, 1200].map(function (w) { return pick.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', ');
    layer.sizes = Math.round(box.getBoundingClientRect().width) + 'px';
    layer.style.objectPosition = '50% 25%';
    layer.onload = function () {
      var last = box.querySelectorAll('img.tw-xf');
      (last.length ? last[last.length - 1] : base).after(layer);
      requestAnimationFrame(function () { requestAnimationFrame(function () { layer.classList.add('on'); }); });
      setTimeout(function () {   // keep only the newest layer
        box.querySelectorAll('img.tw-xf').forEach(function (l) { if (l !== layer) l.remove(); });
      }, FADE + 100);
    };
    layer.src = pick;
  }
  // theme "gallery" sections (e.g. home: Heritage Gandoras / The Kandura): build pools from the linked collection
  function galleryPools() {
    var jobs = [];
    document.querySelectorAll('.section-gallery .gallery__inner').forEach(function (inner) {
      var items = inner.querySelectorAll('.gallery__item');
      if (items.length < 2) return;
      items.forEach(function (it) {
        var a = it.querySelector('a.gallery__item-content-link[href*="/collections/"]') || it.querySelector('a[href*="/collections/"]');
        var fig = it.querySelector('figure');
        if (!a || !fig || fig.hasAttribute('data-tw-pool')) return;
        var handle = a.getAttribute('href').split('/collections/')[1].split(/[?#/]/)[0];
        var kidsOk = /kid|father|boys/.test(handle);
        jobs.push(fetch('/collections/' + handle + '/products.json?limit=60').then(function (r) { return r.json(); }).then(function (j) {
          var urls = [];
          (j.products || []).forEach(function (p) {
            if (!kidsOk && (/Boys'/.test(p.title) || /^Little /.test(p.title))) return;
            (p.images || []).forEach(function (im) {
              var src = (im.src || '').toLowerCase();
              if (!/flow_|shoot_/.test(src) || /detail|58ffc6ee/.test(src)) return;
              if (im.width && im.height && im.width / im.height > 0.9) return;
              urls.push(im.src.split('?')[0] + '?width=900');
            });
          });
          if (urls.length > 1) fig.setAttribute('data-tw-pool', urls.slice(0, 40).join('|'));
        }).catch(function () {}));
      });
    });
    return Promise.all(jobs);
  }
  if (!reduce) galleryPools().then(startRotation);
  function startRotation() {
    groupsOf().forEach(function (tiles, sec) {
      var visible = false, k = 0;
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.15 }).observe(sec);
      setInterval(function () {
        if (!visible || document.hidden) return;
        fadeTo(tiles[k % tiles.length]);
        k++;
      }, STEP);
    });
  }

  /* ---- v37: RL style pagination - keep "1 - N of M items" and "View N more" right, View All loads every page ---- */
  function pagState() {
    document.querySelectorAll('.tw-pag').forEach(function (pag) {
      var grid = document.querySelector('[data-id="' + pag.dataset.section + '"]');
      if (!grid) return;
      var first = parseInt(pag.dataset.twFirst, 10) || 1, total = parseInt(pag.dataset.twTotal, 10) || 0;
      var size = parseInt(pag.dataset.pageSize, 10) || 24;
      var shown = grid.querySelectorAll(':scope > .column:not(.promotion-column)').length;
      var last = Math.min(total, first - 1 + shown), left = total - last;
      var r = pag.querySelector('[data-tw-range]'); if (r) r.textContent = first + ' - ' + last;
      var nx = pag.querySelector('[data-tw-next]'); if (nx) nx.textContent = Math.min(size, left);
      if (left <= 0) pag.classList.add('is-done');
    });
  }
  // the theme's pagination.js binds the button; it is a link (works without JS), so stop the navigation here
  document.addEventListener('click', function (e) {
    var more = e.target.closest('.tw-pag__more');
    if (more) e.preventDefault();
    var all = e.target.closest('.tw-pag__all');
    if (all) {
      e.preventDefault();
      var pag = all.closest('.tw-pag'), btn = pag.querySelector('.tw-pag__more');
      pag.classList.add('is-all');
      (function step() {
        if (pag.classList.contains('is-done') || !btn) { pag.classList.remove('is-all'); return; }
        if (!pag.getAttribute('loading')) btn.click();
        setTimeout(step, 600);
      })();
    }
  }, true);
  pagState();
  var pg = document.getElementById('product-grid');
  if (pg) new MutationObserver(function () { pagState(); }).observe(pg, { childList: true });

  paintWish();
  var t = 0;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(paintWish, 150); }).observe(document.body, { childList: true, subtree: true });
})();
